import getStaticData from '../helpers/getStaticData'
import callAPI from '../helpers/callAPI'
import {
  REQUEST_AIRPORT_ROUTES,
  receiveAirportRoutes,
} from '../actions/airportRoutes'
import capitalizeString from '../helpers/capitalizeString'

const airportRoutes = store => next => action => {
  next(action)

  if (action.type !== REQUEST_AIRPORT_ROUTES) {
    return
  }

  const dispatch = store.dispatch

  try {
    const routesApi = getStaticData('routes')
    const { selectedAirport, routeType, routeId } = action.data
    callAPI(
      { url: `${routesApi.url}?destination=${selectedAirport.key}` },
      { ...routesApi.headers }
    )
      .then(response => {
        const { airports, searchDetails } = store.getState()
        const { primary, secondary, lastSelectedAirport } = searchDetails
        const filteredAirports = `filtered${capitalizeString(
          routeType
        )}Airports`
        const filteredAirportObject = {
          list: airports.list.filter(airport =>
            response.find(routesList => routesList.origin.id === airport.key)
          ),
          title:
            routeType === 'inbound'
              ? `Origins to ${selectedAirport.label}`
              : `Destinations from ${selectedAirport.label}`,
        }
        const updatedSearchDetails = {
          primary,
          secondary,
          [routeId]: {
            ...(routeId === 'primary' ? primary : secondary),
            [filteredAirports]: filteredAirportObject,
            [`${routeType}Airport`]: selectedAirport,
          },
          lastSelectedAirport: {
            ...lastSelectedAirport,
            [routeId]: routeType,
          },
        }
        dispatch(receiveAirportRoutes(updatedSearchDetails))
      })
      .catch(error => {
        throw new Error({ status: 'failure', error })
      })
  } catch (error) {
    console.log(error)
  }
}

export { airportRoutes }
